module.exports = "mutation ($id: ID!) {\n  ResidentialAccountDelete(id: $id) {\n    id\n  }\n}\n"